import React, { ReactElement } from 'react';
import Carousel from '../../Carousel';

const Description: React.FC = (): ReactElement => {
  const TextFromCarousel = [
    {
      key: 't1',
      content: (
        <p className="ml-3">
          <span className="font-bold">Empatie - </span>
          <span className="pr-5">
            Ne &quot;încălțăm&quot; în papucii copiilor și vedem lumea prin
            ochii lor
          </span>
        </p>
      ),
    },
    {
      key: 't2',
      content: (
        <p className="ml-3">
          <span className="font-bold">Respect - </span>
          <span>
            Câștigăm respectul copiilor pentru ca și noi să fim respectați la
            rândul nostru de ei.
          </span>
        </p>
      ),
    },
    {
      key: 't3',
      content: (
        <p className="ml-3">
          <span className="font-bold">Prietenie - </span>
          <span>
            Devenim mai mult decât o autoritate în fața copiilor, devenim
            prietenii și partenerii lor de joacă.
          </span>
        </p>
      ),
    },
    {
      key: 't4',
      content: (
        <p className="ml-3">
          <span className="font-bold">Înțelegere - </span>
          <span>
            Nevoile și dorințele copiilor sunt la fel de importante ca ale
            adulților.
          </span>
        </p>
      ),
    },
    {
      key: 't5',
      content: (
        <p className="ml-3">
          <span className="font-bold">Încredere - </span>
          <span>
            Avem încredere că orice copil poate progresa, în acest fel el va
            reuși cu siguranță.
          </span>
        </p>
      ),
    },
    {
      key: 't6',
      content: (
        <p className="ml-3">
          <span className="font-bold">Motivare - </span>
          <span>Nu există ”nu pot”, există doar ”nu pot încă”.</span>
        </p>
      ),
    },
    {
      key: 't7',
      content: (
        <p className="ml-3">
          <span className="font-bold">Toleranță - </span>
          <span>
            Oferim o îmbrățișare supărării și nemulțumirii atunci când apar, ca
            să le transformăm în zâmbete și voie bună.
          </span>
        </p>
      ),
    },
  ];

  return (
    <div className="w-full bg-primary flex justify-center items-center">
      <div className="w-full h-full overflow-hidden flex justify-center items-center">
        <img
          src="static/resources/Home.jpg"
          className="min-w-[1000px] w-full min-h-[200px]"
          alt="Description"
        />
      </div>
      <div className="p-4 sm:p-0 max-w-[100%] text-light text-lg md:text-xl lg:text-2xl absolute sm:max-w-xl flex flex-col justify-center items-center">
        <div className="ml-3">
          <p className="text-2xl md:text-3xl lg:text-4xl">
            Novalogo înseamnă să oferim copiilor mai mult decât logopedie...
          </p>
          <br />
          <br />
          <p>Oferim:</p>
        </div>
        <Carousel resourceForTextCarousel={TextFromCarousel} type="text" />
      </div>
    </div>
  );
};

export default Description;
